<template>
  <iframe
    :src="`/zoom.html?meetingConfig=${encodeURIComponent(JSON.stringify(meetingConfig))}`"
    frameBorder="0"
    allow="camera;microphone"
    height="100%"
  ></iframe>
</template>

<script>
import axios from "axios";

export default {
  props: {
    meetingNumber: null,
    meetingCode: null,
    userName: null,
    hostMode: null,
    assistantMode: null,
  },
  data() {
    return {
      meetingConfig: null,
    };
  },
  async mounted() {
    const data = window.sessionStorage.getItem(this.$route.params["activity_slug"]);
    if (data) {
      const objectData = JSON.parse(data);
      this.participant = await axios.get(`/event/participants/${objectData.ot_token}`);
    }

    const query = this.$route.query ? Object.assign({}, this.$route.query) : {};
    if (this.participant.firstName) {
      query.firstName = this.participant.firstName;
    }
    if (this.participant.lastName) {
      query.lastName = this.participant.lastName;
    }
    if (this.participant.username) {
      query.userName = this.participant.username;
    }
    if (window.sessionStorage.getItem("accessToken") !== "undefined") {
      query.accessToken = window.sessionStorage.getItem("accessToken");
    }
    if (this.$route.params["team_slug"] && this.$route.params["team_slug"] != "global") {
      query.team = this.$route.params.team_slug;
    }

    this.meetingConfig = await axios.post("/event/zoom/config", {
      meetingNumber: this.meetingNumber,
      meetingCode: this.meetingCode,
      userName: this.userName,
      role: this.hostMode ? 1 : this.assistantMode ? 5 : 0,
      lang: { fr: "fr-FR", en: "en-US" }[this.$i18n.locale],
      leaveUrl: encodeURIComponent(`/e/${this.$store.state.event.slug}?${new URLSearchParams(query)}`),
    });
  },
  async destroyed() {
    // TODO : leave zoom
  },
};
</script>
<style scoped>
iframe {
  width: 100%;
}
</style>
